import type { ChatEvent } from '@/types'

import { AssistantMessage } from './AssistantMessage'
import {
  CLARIFYING_TOOL_NAME,
  ClarifyingQuestionMessage,
} from './ClarifyingQuestionMessage'
import type { BlockPhase, RenderableItem } from './groupEvents'
import { ThinkingMessage } from './ThinkingMessage'
import { ToolCallMessage } from './ToolCallMessage'
import { UserMessage } from './UserMessage'
import { DoneWorkBlock } from './WorkBlock/DoneWorkBlock'
import { LiveWorkBlock } from './WorkBlock/LiveWorkBlock'

export function renderEvent(event: ChatEvent, agentId: 'david' | 'hanna') {
  if (event.type === 'user_message')
    return <UserMessage event={event} key={event.id} />
  if (event.type === 'assistant_message')
    return <AssistantMessage agentId={agentId} event={event} key={event.id} />
  if (event.type === 'thinking_message')
    return <ThinkingMessage event={event} key={event.id} />
  if (event.type === 'tool_call') {
    if (event.toolName === CLARIFYING_TOOL_NAME)
      return <ClarifyingQuestionMessage event={event} key={event.id} />
    return <ToolCallMessage event={event} key={event.id} />
  }
  return null
}

// Live and done are different component types, so a block that finishes
// remounts into a fresh, collapsed fold.
export function renderItem(
  item: RenderableItem,
  agentId: 'david' | 'hanna',
  phase: BlockPhase = 'done'
) {
  if (item.type === 'work_block')
    return phase === 'live' ? (
      <LiveWorkBlock block={item} key={item.id} />
    ) : (
      <DoneWorkBlock block={item} key={item.id} />
    )
  return renderEvent(item, agentId)
}
